import React,{useState} from 'react'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import axios from 'axios';
import appUrl from "../../../../constants/appUrl";

import { useFormik } from 'formik'
import * as Yup from 'yup';
const LoginScreen  = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); 

  const validationSchema = Yup.object({
    userName: Yup.string().required('Required'),
    password: Yup.string().required('Required'),

});
const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      userName:  '',
      password: '',

    },
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const response = await axios.post(`https://qa-knowledgebase.appinsnap.com/api/Auth/Login`,
        values,        {
          headers: {
            'Content-Type': 'application/json'
          }
        }); 
        localStorage.setItem("user", JSON.stringify(response?.data));
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message);
        }

      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <div className="p-fluid formgrid grid">
       
          <div className="field md:col-4"></div>
          <div className="field md:col-4">
            <h2 className="auth-welcome mt-3">Welcome To Z-Knowledge</h2>
            <h1 className="auth-heading mt-0">Log In</h1>
            <h3 className="auth-login mt-0">Login to access your account</h3>
            <form style={{ width: "100%" }} className="grid p-fluid justify-content-left align-items-left mt-5">

              <InputText
                className="auth-welcome mt-3"
                placeHolder="Enter email"
                type="text"
                id="userName"
                name="userName"
                value={formik.values.userName}
                onChange={formik.handleChange}
              />
               {formik.touched.userName && formik.errors.userName ? (
                <div className="error">{formik.errors.userName}</div>
              ) : null}
              <InputText
                className="auth-welcome mt-3"
                placeHolder="Enter password"
                type="password"
                id="password"
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
              />
               {formik.touched.password && formik.errors.password ? (
                <div className="error">{formik.errors.password}</div>
              ) : null}

              <Button type="submit" className="customButton mt-3" label="Log In" onClick={formik.handleSubmit} />

            </form>
          </div>
          <div className="field md:col-4"></div>
        </div>
      
    </>
  )
}

export default LoginScreen 